import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import HeroCommercial from "@/components/pymes/HeroCommercial";
import PainPoints from "@/components/pymes/PainPoints";
import ServicePlans from "@/components/pymes/ServicePlans";
import Benefits from "@/components/pymes/Benefits";
import ProcessSteps from "@/components/pymes/ProcessSteps";
import CommercialTestimonials from "@/components/pymes/CommercialTestimonials";
import Guarantees from "@/components/pymes/Guarantees";
import FAQCommercial from "@/components/pymes/FAQCommercial";
import CommercialForm from "@/components/pymes/CommercialForm";
import EmergencyContact from "@/components/pymes/EmergencyContact";
import Footer from "@/components/Footer";
import PasswordGate from "@/components/PasswordGate";

const MantenimientoPymes = () => {
  return (
    <PasswordGate password="gtxdesarrollo" storageKey="pymes_access">
      <Helmet>
        <title>Mantenimiento Eléctrico para PYMEs | Desde $49.990 | MYCING</title>
        <meta name="description" content="Mantenimiento eléctrico certificado para locales comerciales, tiendas y PYMEs en Santiago. Prevención de incendios, normalización SEC, precios económicos. ¡Cotiza gratis!" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Mantenimiento Eléctrico para PYMEs | MYCING" />
        <meta property="og:description" content="Protege tu local comercial con nuestro servicio de mantenimiento eléctrico certificado. Desde $49.990. Revisión GRATIS." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mycing.cl/mantenimiento-electrico-pymes" />
        <meta property="og:image" content="https://mycing.cl/images/og-pymes.jpg" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mantenimiento Eléctrico para PYMEs | MYCING" />
        <meta name="twitter:description" content="Protege tu local comercial con nuestro servicio de mantenimiento eléctrico certificado." />
        
        {/* Schema.org */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Mantenimiento Eléctrico Comercial",
            "provider": {
              "@type": "LocalBusiness",
              "name": "MYCING Ltda",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Nicanor Molinare 3228",
                "addressLocality": "Macul",
                "addressRegion": "Región Metropolitana",
                "addressCountry": "CL"
              },
              "telephone": "+56223456789",
              "email": "contacto@mycing.cl"
            },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "CLP",
              "price": "49990",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "priceCurrency": "CLP",
                "price": "49990"
              }
            },
            "areaServed": {
              "@type": "City",
              "name": "Santiago"
            }
          })}
        </script>
      </Helmet>

      <div className="min-h-screen">
        <Navigation />
        <HeroCommercial />
        <PainPoints />
        <ServicePlans />
        <Benefits />
        <ProcessSteps />
        <CommercialTestimonials />
        <Guarantees />
        <FAQCommercial />
        <CommercialForm />
        <EmergencyContact />
        <Footer />
      </div>
    </PasswordGate>
  );
};

export default MantenimientoPymes;
